import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import SkuDataSet from "../data/UnidadeArmazenamentoDataSet";
import { hasInCache } from "../../helper/cacheHelper";
import UnidadeArmazenamento from "../classes/UnidadeArmazenamento";

export default function AutocompleteSKUEstoque(props: AutocompleteSKUProps) {
    const dataSet = new SkuDataSet();
    const [value, setValue] = useState<string>(props.value);
    const [data, setData] = useState<UnidadeArmazenamento[]>([]);
    const [dataFilter, setDataFilter] = useState<UnidadeArmazenamento[]>([]);

    useEffect(() => {
        if (hasInCache("UnidadeArmazenamentoCache")) {
            setData(JSON.parse(String(localStorage.getItem("UnidadeArmazenamentoCache"))));

        } else {
            dataSet.ListarAtivos().then((result) => setData(result));
        }
        /*    if (hasInCache("CodigoFornecedorSAPSelecionado")) {
                var _codigo: string = String(localStorage.getItem("CodigoFornecedorSAPSelecionado"));
                setDataFilter(data.filter(f => f.codigoFornecedorSAP.toString().startsWith(_codigo)));
            }*/
    }, [])


    useEffect(() => {
        if (dataFilter !== null && dataFilter !== undefined && dataFilter.length === 1) {
            localStorage.setItem("UnidadeArmazenamentoSel", String(dataFilter[0].idSKU));
            props.onChange(String(dataFilter[0].idSKU));
        }
        else
            if (dataFilter.length !== 1)
                localStorage.removeItem("UnidadeArmazenamentoSel");
    }, [dataFilter])

    const handlerOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDataFilter(data.filter(f => f.idSKU.toString().startsWith(event.target.value)))
        props.onChange(event.target.value.replace(/\D/g,''));
    }

    return (
        <>
            <Autocomplete
                freeSolo
                id="autocompleteSKU"
                value={value}
                disableClearable
                options={data.map((option: any) => option.idSKU + ' - ' + option.descricao)}
                onChange={(e) => { setDataFilter(data.filter(f => (f.idSKU.toString() + ' - ' + f.descricao) === String(e.currentTarget.textContent))); }}
                renderInput={(params) => (<TextField
                    {...params}
                    label="Buscar SKU"
                    InputProps={{
                        ...params.InputProps,
                        type: 'search',
                    }}
                    onChange={handlerOnChange}
                />
                )}
            />
        </>
    )
}

interface AutocompleteSKUProps {
    onChange?:any
    value?:any
}
